<template>
  <v-app :dark="isDark" class="bg">
    <SnackBar
      v-if="isSnackBar"
      :visible="isSnackBar"
      :message="getSnackBarContent['message']"
      :header="getSnackBarContent['header']"
      :icon="getSnackBarContent['icon']"
      @update:snackbar="updateSnackbar" />
    <Dialogue
      v-if="isDialog"
      :visible="isDialog"
      :reference="getDialogContent['ref']"
      :header="getDialogContent['header']"
      :contents="getDialogContent['contents']"
      :icon="getDialogContent['icon']"
      :actions="getDialogContent['actions']" />
    <ProgressBar :visible="getProgressBar" />
    <router-view />
    <CopyrightFooter  />
  </v-app>
</template>

<script>
import SnackBar from '@/components/utility/SnackBar.vue'
import Dialogue from '@/components/utility/Dialogue.vue'
import ProgressBar from '@/components/utility/ProgressBar.vue'
import './stylus/main.styl'
import {
  mapGetters,
  mapMutations
} from 'vuex'

export default {
  name: 'App',
  components: {
    SnackBar,
    Dialogue,
    ProgressBar
  },
  computed: {
    ...mapGetters(['isSnackBar', 'getSnackBarContent', 'isDialog', 'getDialogContent', 'getProgressBar', 'getGeneralState']),
    isDark() {
      return this.getGeneralState('theme_dark')
    }
  },
  created() {
    window.addEventListener('beforeunload', this.REMOVE_DOWNLOAD_LIST)
  },
  mounted() {
    this.SET_PROGRESS_BAR(false)
    this.SET_SHOW_DIALOG(false)
    this.SET_SHOW_SNACKBAR(false)
  },
  methods: {
    ...mapMutations('settings', ['REMOVE_DOWNLOAD_LIST']),
    ...mapMutations(['SET_SHOW_SNACKBAR', 'SET_SHOW_DIALOG', 'SET_PROGRESS_BAR']),
    updateSnackbar(payload) {
      this.SET_SHOW_SNACKBAR(payload)
    }
  }
}
</script>

<style>
html {
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: #49516b;
  /* outline: 1px solid #49516b; */
}

::-webkit-scrollbar-track {
  border-radius: 6px;
  background-color: #B1B4B9;
  -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.3);
}

/* ::-webkit-scrollbar-thumb:hover {
  background-color: #49516b;
  outline: 3px solid #49516b;
} */

.v-table {
  background-color: var(--v-primary-base) !important;
}

.v-datatable .v-datatable__actions {
  background-color: var(--v-primary-base) !important;
}

.v-expansion-panel .v-expansion-panel__container {
  background-color: var(--v-primary-base) !important;
}

/* To change the background color of rows on hover */
.v-datatable tbody tr:hover {
  background-color: rgba(
    255,
    255,
    255,
    0.2
  ) !important; /* Change to your desired hover background color */
  cursor: pointer;
}

/* To apply styles to the header row */
.v-datatable thead th {
  font-size: 14px !important;
  border-bottom: 1px solid #334079;
  padding: 0px 10px !important;
}

.v-datatable tbody tr:not(:last-child) {
  border-bottom: 1px solid #334079;
}

.theme--dark .v-text-field input {
  caret-color: #fff;
}

.theme--light .v-text-field input {
  caret-color: #000;
}

.link-text {
  color: #000427;
  font-size: 17px;
  cursor: pointer;
  text-decoration: none;
  position: relative;
}

.link-text::after {
  content: '';
  position: absolute;
  width: 0;
  height: 1px;
  bottom: -2px;
  left: 50%;         
  transform: translateX(-50%); 
  background-color: #000427;;
  transition: width 0.3s ease-in-out;
}

.link-text:hover::after {
  width: 100%;
}

.unq__caret input {
  caret-color: #000 !important;
}

.grecaptcha-badge {
  visibility: hidden;
}
</style>
